import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const METRIC_LABELS = {
  inspectionCount: "Inspection Count",
  score: "Avg Score",
  findingCount: "Finding Count",
};

const formatPeriodLabel = (period, granularity) => {
  if (!period) return "";
  if (granularity === "monthly") {
    const [year, month] = period.split("-");
    return new Date(Number(year), Number(month) - 1, 1).toLocaleDateString("en-GB", { month: "short", year: "2-digit" });
  }
  const date = new Date(`${period}T00:00:00`);
  if (granularity === "weekly") {
    return `W/C ${date.toLocaleDateString("en-GB", { day: "numeric", month: "short" })}`;
  }
  return date.toLocaleDateString("en-GB", { day: "numeric", month: "short" });
};

const InspectionTrendChart = ({ list = [], metric = "inspectionCount", granularity = "weekly", compact = false }) => {
  const { width } = useWindowDimensions();
  const [chartData, setChartData] = useState({ series: [], options: {} });
  const height = compact ? 220 : width > 1700 ? 300 : 250;

  useEffect(() => {
    setChartData({
      series: [
        {
          name: METRIC_LABELS[metric] || "Value",
          data: list?.map((e) => e.value) || [],
        },
      ],
      options: {
        chart: {
          type: "area",
          height,
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        colors: ["#e11d48"],
        stroke: { curve: "smooth", width: 2 },
        fill: {
          type: "gradient",
          gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05 },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: list?.map((e) => formatPeriodLabel(e.period, granularity)) || [],
          labels: { rotate: -45, style: { fontSize: "10px" }, hideOverlappingLabels: true },
        },
        yaxis: {
          labels: { style: { fontSize: "11px" } },
        },
        grid: { borderColor: "#f0f1f3" },
        tooltip: { x: { show: true } },
      },
    });
  }, [list, metric, granularity, height]);

  if (!list?.length) {
    return null;
  }

  return (
    <ReactApexChart options={chartData.options} series={chartData.series} type="area" height={height} />
  );
};

export default InspectionTrendChart;
